import { render, staticRenderFns } from "./SpecialProceduresBlock.vue?vue&type=template&id=4a0d9d6d&lang=pug&"
import script from "./SpecialProceduresBlock.vue?vue&type=script&lang=js&"
export * from "./SpecialProceduresBlock.vue?vue&type=script&lang=js&"
import style0 from "./SpecialProceduresBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports